const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M240,112h-80c-8.8,0-16-7.2-16-16V16c0-8.8,7.2-16,16-16h80c8.8,0,16,7.2,16,16v80c0,8.8-7.2,16-16,16ZM240,16h-80v80h80V16ZM96,256H16c-8.8,0-16-7.2-16-16v-80c0-8.8,7.2-16,16-16h80c8.8,0,16,7.2,16,16v80c0,8.8-7.2,16-16,16ZM96,160H16v80h80v-80ZM96,112H16c-8.8,0-16-7.2-16-16V16C0,7.2,7.2,0,16,0h80c8.8,0,16,7.2,16,16v80c0,8.8-7.2,16-16,16ZM96,16H16v80h80V16Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.6,236.2l-33-33,33-33c4.6-4.6,4.6-12,0-16.5s-12-4.6-16.5,0l-33,33-33-33c-4.6-4.6-12-4.6-16.5,0s-4.6,12,0,16.5l33,33-33,33c-4.6,4.6-4.6,12,0,16.5s12,4.6,16.5,0l33-33,33,33c4.6,4.6,12,4.6,16.5,0s4.6-12,0-16.5Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDelete);
export default __webpack_public_path__ + "static/media/menu-delete.d43517a15e910a4174ee3137a12f8ed2.svg";
export { ForwardRef as ReactComponent };